<template>
  <div>
    <el-card shadow="always">
      <div style="display: flex; justify-content: space-between">
        <div style="display: flex">
          <el-input size="small" style="width: 250px" placeholder="搜索名称关键字" clearable v-model.trim="params.keyword" @change="getData()">
            <el-button slot="append" icon="el-icon-search" @click="getData"></el-button>
          </el-input>
          <el-button size="mini" icon="el-icon-refresh" style="width: 80px; margin: 0 2px" @click="getData">刷新</el-button>
        </div>
        <el-button size="small" type="primary" @click="saveDialog()" v-if="$isPerm('employee-save')">添加职员</el-button>
      </div>
    </el-card>
    <el-table height="600" size="small" :data="tableData.list" border row-key="id" class="box-card mt10">
      <el-table-column prop="id" label="ID" width="50"> </el-table-column>
      <el-table-column prop="name" label="姓名" width="120"></el-table-column>
      <el-table-column label="性别" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.gender == 1">男</span>
          <span v-if="scope.row.gender == 2">女</span>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="手机" width="150"></el-table-column>
      <el-table-column prop="department_name" label="部门" width="120"></el-table-column>
      <el-table-column prop="position" label="职位" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.position == 1">股东</span>
          <span v-if="scope.row.position == 2">业务员</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">正常</span>
          <span v-if="scope.row.status == 0">禁用</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" width="150"></el-table-column>
      <el-table-column label="创建时间" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.create_time | date }}</span>
        </template>
      </el-table-column>
      <el-table-column label="更新时间" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.update_time | date }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="saveDialog(scope.row)" v-if="$isPerm('employee-save')">编辑</el-button>
          <el-button size="mini" type="warning" @click="deleteData(scope.row.id)" v-if="$isPerm('employee-delete')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total,sizes,prev, pager, next"
      :page-sizes="[15, 30, 50, 100]"
      :total="tableData.total"
      :page-size="tableData.page_size"
      :current-page="tableData.page"
      @current-change="pageChange"
      @size-change="pageSizeChange"
      class="box-card pd10 mt10"
    >
    </el-pagination>
    <div>
      <el-dialog :title="saveDialogTitle" :visible.sync="saveDialogShow" width="500px" :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
        <div style="padding: 20px">
          <el-form size="small" ref="formRef" :model="formData" :rules="rules" label-width="120px">
            <el-form-item label="姓名" prop="name" :error="errMsg.name">
              <el-input v-model="formData.name" style="width: 280px"></el-input>
            </el-form-item>
            <el-form-item label="性别">
              <el-select v-model="formData.gender" clearable placeholder="请选择" style="width: 280px">
                <el-option label="男" :value="1"></el-option>
                <el-option label="女" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="手机" prop="phone" :error="errMsg.phone">
              <el-input v-model="formData.phone" style="width: 280px"></el-input>
            </el-form-item>
            <el-form-item label="部门" prop="dept_id" :error="errMsg.dept_id">
              <department v-model="formData.dept_id" width="280"></department>
            </el-form-item>
            <el-form-item label="职位" prop="position" :error="errMsg.position">
              <position-option v-model="formData.position" style="width: 280px"></position-option>
            </el-form-item>
            <el-form-item label="备注" prop="remark" :error="errMsg.remark">
              <el-input type="textarea" :rows="2" maxlength="200" show-word-limit v-model="formData.remark" style="width: 280px"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="form-but">
          <el-button size="small" type="primary" :loading="loading" @click="saveData()">保 存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Department from '@/components/department/select.vue';
import PositionOption from '@/components/position/option.vue';
export default {
  name: 'employeeList',
  components: {
    Department,
    PositionOption
  },
  created() {
    this.getData();
  },
  data() {
    return {
      saveDialogTitle: '',
      saveDialogShow: false,
      loading: false,
      tableData: {
        page: 0,
        page_count: 0,
        page_size: 0,
        total: 0,
        list: []
      },
      params: {
        page: 1,
        page_size: 15,
        keyword: ''
      },
      formData: {
        id: 0,
        name: '',
        gender: '',
        phone: '',
        dept_id: '',
        position: '',
        remark: ''
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入手机', trigger: 'blur' }],
        dept_id: [{ required: true, message: '请选择部门', trigger: 'blur' }],
        position: [{ required: true, message: '请选择职位', trigger: 'blur' }]
      },
      errMsg: {},
      num: 0,
      selectedIds: []
    };
  },
  methods: {
    //新增/编辑
    saveDialog(row) {
      this.saveDialogShow = true;
      this.saveDialogTitle = '添加职员';
      this.formData = {
        id: 0,
        name: '',
        gender: '',
        phone: '',
        position: '',
        remark: ''
      };
      if (row) {
        this.saveDialogTitle = '编辑职员';
        this.formData = _.cloneDeep(row);
      }
    },
    // 保存数据
    async saveData() {
      this.$refs.formRef.validate(async vaild => {
        if (!vaild) return;
        this.setEmptyErrMsg();
        this.loading = true;
        let data = _.cloneDeep(this.formData);
        await this.$api.employee.save(data).then(res => {
          this.loading = false;
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.saveDialogShow = false;
            this.getData();
          } else {
            for (let k in res.data) {
              this.errMsg[k] = res.data[k];
            }
          }
        });
      });
    },
    //初始化错误信息对象
    setEmptyErrMsg() {
      this.errMsg = {};
      this.$refs.formRef.fields.map(i => {
        this.$set(this.errMsg, i.prop, '');
      });
    },
    //删除
    async deleteData(id) {
      if (this.selectedIds.length == 0 && !id) {
        this.$message.warning('未选中数据');
        return;
      }
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let params = {
            ids: this.selectedIds.join(',')
          };
          if (id) {
            params.ids = id;
          }
          this.loading = true;
          await this.$api.employee.delete(params).then(res => {
            this.loading = false;
            if (res.code != 200) return;
            this.$message.success(res.msg);
            this.getData();
          });
        })
        .catch(() => {});
    },
    // 获取数据
    async getData() {
      let params = Object.assign({}, this.params);
      await this.$api.employee.list(params).then(res => {
        if (res.code == 200) {
          this.tableData = res.data;
        }
      });
    },
    //多选
    handleSelectionChange(selectedItems) {
      let list = [];
      for (const val of selectedItems) {
        if (!list.includes(val.id)) {
          list.push(val.id);
        }
      }
      this.selectedIds = list;
    },
    // 分页切换
    pageChange(page) {
      this.params.page = page;
      this.getData();
    },
    // 分页大小切换
    pageSizeChange(pageSize) {
      this.params.page_size = pageSize;
      this.getData();
    },
    //刷新
    refresh() {
      this.getData();
    }
  }
};
</script>
